/**
 * Admin Services
 */

angular.module("admin")

	.factory("AdminService", ["$resource", "$http", "SharedProperties", "CONSTANTS", "ENV", function ($resource, $http, SharedProperties, CONSTANTS, ENV) {
		return {

			getAllSchemas: function () {
				return $http.get(ENV.API_URL + "/admin/schemas");
			},

			doesSchemaExists: function (schemaName) {
				return $http.get(ENV.API_URL + "/admin/schemas/" + schemaName);
			},

			getAllAccessNameModes: function () {
				return $http.get(ENV.API_URL + "/admin/accessNameModes");
			},


			getUserById: function (idUser) {
				return $http.get(ENV.API_URL + "/admin/users/" + idUser);
			},

			/**
			 * Récupérer les infos d'un utilisateur d'après son token d'authent.
			 * @returns {*}
			 */
			getUserByToken: function () {
				return $http.get(ENV.API_URL + "/admin/users/token/" + SharedProperties.getApiToken());
			},

			getCurrentSchema: function() {
				return $http.get(ENV.API_URL + "/admin/users/current-schema/" + SharedProperties.getApiToken());
			},

			/**
			 * Récupérer les infos d'un utilisateur d'après son token de password.
			 * @returns {*}
			 */
			getUserByPasswordToken: function (token) {
				return $http.get(ENV.API_URL + "/admin/users/password-token/" + token);
			},

			getSchoolItiSettingsByToken: function () {
				return $http.get(ENV.API_URL + "/admin/users/school-iti-settings");
			},

			getCompanyByToken: function () {
				return $http.get(ENV.API_URL + "/companies/byToken",
					{
						params: {
							token: SharedProperties.getApiToken()
						}
					});
			},


			closeSubscription: function (id) {
				return $http.put(ENV.API_URL + "/admin/subscriptions/" + id,
					{
						"state": "CLOSED"
					});
			},

			modifySubscriptionEndDate: function (id, date) {
				return $http.put(ENV.API_URL + "/admin/subscriptions/" + id,
					{
						"endDate": date
					});
			},

			getAllLicenceTypes: function () {
				return $http.get(ENV.API_URL + "/admin/products");
			},

			getAll: function () {
				return $http.get(ENV.API_URL + "/admin/companies");
			},


			getAllSubscriptions: function () {
				return $http.get(ENV.API_URL + "/admin/subscriptions");
			},


			addSubscription: function (subscription) {
				return $http.post(ENV.API_URL + "/admin/subscriptions",
					{
						"clientId": subscription.selectedClient.id,
						"endDate": subscription.endDate,
						"productId": subscription.selectedProduct.id,
						"nbLicences": subscription.nbLicences
					});

			},

			postLicence: function (nb, id, label) {
				return $http.post(ENV.API_URL + "/admin/ajoutLicence",
					{
						"token": SharedProperties.getApiToken(),
						"nbLicence": nb,
						"idCompany": id,
						"label": label
					});
			},

			addNameAccessModeToUser: function (idUser, numRightAccess) {
				return $http.post(ENV.API_URL + "/admin/users/" + idUser + "/accessNameModes/" + numRightAccess);
			},


			deleteUserAccessModes: function (userId, accessNameModeId) {
				return $http.delete(ENV.API_URL + "/admin/users/" + userId + "/accessNameModes/" + accessNameModeId);
			},

			deleteUser: function (userId) {
				return $http.delete(ENV.API_URL + "/admin/users/" + userId);
			},


			/**
             * Récupérer la liste des objects CompanyAdmin.
             * @returns {*}
             */
			getAllCompanyAdmins: function () {
				return $http.get(ENV.API_URL + "/admin/companies");
			}

		};
	}
	]);
